

(function () {


  'use strict';

  let tileContainerLinks = document.querySelectorAll('.tile__container a');
  Array.prototype.forEach.call(tileContainerLinks, function(tileLink) {
    //Should probably just toggle, but this gives addtl flexibility for other
    //changes later.
    tileLink.addEventListener('focus', bubbleHover);
    tileLink.addEventListener('blur', bubbleHover);

  });

  function bubbleHover(evt) {
    var containerSelector = '.tile__container';
    var topContainer = evt.target.closest(containerSelector);
    if(topContainer.parentNode.classList.contains('tile--titles')) {
      var topContainer =  topContainer.parentNode;
      var containerSelector = '.tile--titles';
    }
    if(evt.type == 'focus'){

      let allTileContainers = document.querySelectorAll(containerSelector);
      Array.prototype.forEach.call(allTileContainers, function(item) {

          item.classList.remove('tile-focus');

      });

      topContainer.classList.add('tile-focus');
    } else {
      topContainer.classList.remove('tile-focus');
    }
  }



})();
